export type Font = {
  style: {
    fontFamily: string,
  },
}

export class FontManager {

  private static defaultFont: Font = {
    style: {
      fontFamily: "sans-serif",
    }
  };

  private static instance: FontManager;

  static getInstance(): FontManager {
    if (!this.instance) {
      this.instance = new FontManager();
    }
    return this.instance;
  }

  private constructor() {
  }

  private readonly map = new Map<string, Font>();

  registerFont(name: string, font: Font): void {
    this.map.set(name, font);
  }

  getFont(name: string): Font {
    return this.map.get(name) || FontManager.defaultFont;
  }
}